// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

const SUPABASE_URL = "https://awexjlehiosjxrfgwder.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF3ZXhqbGVoaW9zanhyZmd3ZGVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgzMzc2OTUsImV4cCI6MjA1MzkxMzY5NX0.ligmSJr_Vi7QDOfzsuz12Y91SOfv5CIE0ldUi4EQA_s";

// Create a single supabase client for interacting with your database
export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);

// Export the database types for use in other files
export type { Database } from './database.types';
